// extracted by mini-css-extract-plugin
export default {"custombutton":"common_custombutton__YI5u1"};